import BaseModel from "../core/BaseModel";
export default class FactoryModel extends BaseModel {
  constructor() {
    super(
      {
        name: "factory",
        tableName: "factory",
        label: "Nhà máy/ Trang trại",
        display_key: "name",
        default_order: { key: "created_at", direction: "asc" },
      },
      {
        stt: {
          name: "stt",
          label: "STT",
          type: "Computed",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: { 
            name: 'id', 
            type: "Uuid", 
            label: 'ID', 
            primaryKey: true,
            display: false
        },
        name: {
            name: 'name',
            type: "TEXT",
            label: 'Tên nhà máy/ trang trại',
            sortable: false,
            // width: 20,
            filter: {type: 'input',match: 'contains'}
        },
        type: {
          name: "type",
          type: "Selection",
          label: "Phân loại cơ sở",
          sortable: false,
          options: [
            { label: "Nhà máy", value: "factory" },
            { label: "Trang trại", value: "farm" },
          ],
          filter: { type: "select", optionLabel: "label", optionKey: "value", match: "equals" },
        },
        factory_users_text: {
          name: 'factory_users_text',
          type: "TEXT",
          label: 'Quản lý/ Trưởng trại',
          sortable: false,
          // width: 20,
          filter: {type: 'input',match: 'contains'}
        },
        address: {
          name: 'address',
          type: "TEXT",
          label: 'Địa chỉ',
          sortable: false,
          // width: 20,
          filter: {type: 'input',match: 'contains'}
        },
        zone: {
          name: 'zone',
          label: 'Khu vực',
          type: "MultiSelect",
          sortable: false,
          filter: { type: 'SelectScroll', optionLabel: 'name', optionKey: 'id', match: 'equals' },
          minWidth : 10,
        },
        active : {
          name: 'active', 
          type: "Selection", 
          custom: 'SelectionText',
          label: 'Hiển thị',
          class: 'center',
          width: 6,
          options: [
            {label: "Hiển thị",value: true},
            {label: "Ẩn",value: false}
          ],
          filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
        },
        updated_by : {
          name: 'updated_by', 
          type: "TEXT", 
          label: 'Người cập nhật',
          width : 10,
        },
        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối",
          width : 10,
          // filter: { type: "DateRange", match: "contains" },
        },
        created_at: {
          name: "created_at",
          type: "Datetime",
          label: "Ngày tạo",
          filter: { type: "DateRange", match: "contains" },
          display: false,
        }
      }
    );
  }
}
